import { IReturnDelivery } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { ReturnDeliveryComponentModel } from 'src/app/business/return-delivery/return-delivery-component-model';

@Injectable()
export class ReturnDeliveryResolver implements Resolve<IReturnDelivery> {
  constructor(private _returnDeliveryComponentModel: ReturnDeliveryComponentModel) {}

  resolve(route: ActivatedRouteSnapshot) {
    return this._returnDeliveryComponentModel.get(route.paramMap.get('returnDeliveryId'));
  }
}
